import { useContext } from "react";
import AppGlobalsContext from "app/AppGlobalsContext";

type AppGlobals = {
	envVars?: {
		ENVIRONMENT?: string;
	};
};

const VISIBLE_ENVIRONMENTS = ["test", "canary", "preprod"];

/**
 * Returns true when the current environment is one where dev tools may be displayed.
 */
export const useDevToolsVisibility = (): boolean => {
	const { envVars = {} } = useContext(AppGlobalsContext) as AppGlobals;
	const environment = envVars.ENVIRONMENT ?? "";

	return VISIBLE_ENVIRONMENTS.some(env => environment.includes(env));
};
